import React, { useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import styles from "../../styles/profile.module.css";
import { toast } from "react-toastify";
import { PostTokenApi } from "../../api/api-service";
import { API_Path, companyName } from "../../const";
import usePageTitle from "../customHook/usePageTitle";
import { Form, Formik } from "formik";
import { errorContainer, formAttr } from "../common/CommonFun";
import * as Yup from "yup";
import { AuthContext } from "../../context/AuthContext";

export default function SafetyPhraseInfo(props) {
    usePageTitle("User Account", true);
    const { getCurrentUserDetails } = useContext(AuthContext);
    const [errorMsg, setErrorMsg] = useState({
        emailErrorMsg: [],
        loginErrorMsg: [],
    });
    const [btnLoader, setBtnLoader] = useState({
        emailLoader: false,
        loginLoader: false,
    });

    const setEmailSubmitData = (formData, resetForm) => {
        setBtnLoader({ emailLoader: true });
        const emailSafety = new Promise((resolve) => {
            resolve(PostTokenApi(API_Path.userEmailSafertCode, { ...formData }));
        });
        emailSafety.then((res) => {
            if (res.data.Isvalid) {
                resetForm();
                toast.success(res.data.Successes[0]);
                getCurrentUserDetails();
                props.handleClose();
            } else {
                setErrorMsg({ ...errorMsg, emailErrorMsg: res.data.Isvalid });
                toast.error(res.data.Isvalid[0]);
            }
            setBtnLoader({ emailLoader: false });
        });
    };

    const setLoginSubmitData = (formData, resetForm) => {
        setBtnLoader({ loginLoader: true });
        const loginSafetyData = new Promise((resolve) => {
            resolve(PostTokenApi(API_Path.userLoginSafertCode, { ...formData }));
        });
        loginSafetyData.then((res) => {
            if (res.data.Isvalid) {
                resetForm();
                toast.success(res.data.Successes[0]);
                getCurrentUserDetails();
                props.handleClose();
            } else {
                setErrorMsg({ ...errorMsg, loginErrorMsg: res.data.Isvalid });
                toast.error(res.data.Isvalid[0]);
            }
            setBtnLoader({ loginLoader: false });
        });
    };

    return (
        <Modal show={props.show} size="lg" centered className={styles.verify_mail_modal}>
            <Modal.Header className={`${styles.auth_modal_head} `}>
                <Modal.Title className={`${styles.auth_modal_title}`}>
                    {props.safetyFlag == "email" ? <h6 className="mb-0 me-3">E-mail Safety Phrase</h6> : <h6 className="mb-0 me-3">Login Safety Phrase</h6>}
                </Modal.Title>
                <div
                    onClick={() => {
                        props.handleClose();
                        setBtnLoader({ emailLoader: false, loginLoader: false });
                    }}
                    className={styles.close_modal_icon}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg>
                </div>
            </Modal.Header>
            <Modal.Body>
                <div className={`${styles.auth_modal_body}`}>
                    {props.safetyFlag == "email" ? (
                        <div className="safety-item">
                            <p>Displayed in the e-mail from {companyName.toLowerCase()} to prevent the user from visiting a phishing website.</p>
                            <div className={styles.safety_phrase}>
                                <p>
                                    Set this e-mail security phrase to prevent phishing attempts. This code shall be displayed whenever you login to {companyName.toLowerCase()} or receive an e-mail
                                    from us.
                                </p>
                                <div>
                                    {props?.EmailSafetyCode && (
                                        <div className={styles.safety_phrase_text}>
                                            <span>Current E-mail Safety Code :</span> <b>{props.EmailSafetyCode}</b>
                                        </div>
                                    )}
                                    <Formik
                                        initialValues={{ EmailSafetyCode: "" }}
                                        validationSchema={Yup.object().shape({
                                            EmailSafetyCode: Yup.string().required("New e-mail safety is required."),
                                        })}
                                        onSubmit={(values, { resetForm }) => {
                                            setEmailSubmitData(values, resetForm);
                                        }}
                                    >
                                        {(runform) => {
                                            const { touched, errors } = runform;
                                            return (
                                                <Form onSubmit={runform.handleSubmit}>
                                                    <div className={styles.personalinfocontent}>
                                                        <label>
                                                            New Email Safety
                                                            <span className={styles.asterisk}>*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter code"
                                                            name="EmailSafetyCode"
                                                            maxLength={20}
                                                            className={`${styles.form_input} ${errors.EmailSafetyCode && touched.EmailSafetyCode ? "input-error" : ""} `}
                                                            {...formAttr(runform, "EmailSafetyCode")}
                                                        />
                                                        {errorContainer(runform, "EmailSafetyCode")}
                                                    </div>
                                                    <div className="form-group">
                                                        <div className={`${styles.personal_info_btn} text-center d-flex pt-3`}>
                                                            <button
                                                                type="button"
                                                                className={`${styles.button} ${styles.button_border}`}
                                                                onClick={() => {
                                                                    runform.resetForm();
                                                                    setErrorMsg({ ...errorMsg, emailErrorMsg: [] });
                                                                }}
                                                            >
                                                                Clear
                                                            </button>
                                                            <button type="submit" className={`${styles.button} primary_button`} disabled={btnLoader.emailLoader}>
                                                                Save
                                                                {btnLoader.emailLoader && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </Form>
                                            );
                                        }}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="safety-item">
                            <p>
                                Displayed in the user login window. By confirming your verification code, you can prevent phishing attempts from fake {companyName.toLowerCase()} e-mails and websites.
                            </p>
                            <div className={styles.safety_phrase}>
                                <p>Set this login security phrase to prevent phishing attempts. This code shall be displayed whenever you login to your {companyName.toLowerCase()} user account.</p>
                                {props?.LoginSafetyCode && (
                                    <div className={styles.safety_phrase_text}>
                                        <span>Current Login Safety Code :</span> <b>{props?.LoginSafetyCode}</b>
                                    </div>
                                )}
                                <Formik
                                    initialValues={{
                                        LoginSafetyCode: "",
                                    }}
                                    validationSchema={Yup.object().shape({
                                        LoginSafetyCode: Yup.string().required("New login safety is required."),
                                    })}
                                    onSubmit={(values, { resetForm }) => {
                                        setLoginSubmitData(values, resetForm);
                                    }}
                                >
                                    {(runform) => {
                                        const { touched, errors } = runform;
                                        return (
                                            <Form onSubmit={runform.handleSubmit}>
                                                <div className={styles.personalinfocontent}>
                                                    <label>
                                                        New Login Safety
                                                        <span className={styles.asterisk}>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter code"
                                                        name="LoginSafetyCode"
                                                        maxLength={20}
                                                        className={`${styles.form_input} ${errors.LoginSafetyCode && touched.LoginSafetyCode ? "input-error" : ""} `}
                                                        {...formAttr(runform, "LoginSafetyCode")}
                                                    />
                                                    {errorContainer(runform, "LoginSafetyCode")}
                                                </div>
                                                <div className="form-group">
                                                    <div className={`${styles.personal_info_btn} text-center d-flex pt-3`}>
                                                        <button
                                                            type="button"
                                                            className={`${styles.button} ${styles.button_border}`}
                                                            onClick={() => {
                                                                runform.resetForm();
                                                                setErrorMsg({ ...errorMsg, loginErrorMsg: [] });
                                                            }}
                                                        >
                                                            Clear
                                                        </button>
                                                        <button type="submit" className={`${styles.button} primary_button`} disabled={btnLoader.loginLoader}>
                                                            Save
                                                            {btnLoader.loginLoader && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>}
                                                        </button>
                                                    </div>
                                                </div>
                                            </Form>
                                        );
                                    }}
                                </Formik>
                            </div>
                        </div>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
}
